<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="primary--text text-capitalize font-weight-bold">{{tittle}}</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<div class="py-2"><v-divider></v-divider></div>
					<v-form ref="formProfile" @submit.prevent="save">
						<v-row align="center" justify="center">
							<v-col cols="12" class="text-center">
								<div class="pb-4" v-if="type == 'user_name'">
									<div class="text-body-1 text-left font-weight-bold pb-1">Nama</div>
									<v-text-field v-model="profile.user_name" validate-on-blur single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" :rules="rules.name"></v-text-field>
								</div>
								<div class="pb-4" v-if="type == 'user_birthdate'">
									<div class="text-body-1 text-left font-weight-bold pb-1">Tanggal Lahir</div>
									<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field outlined dense :value="convertDate(profile.user_birthdate)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details :rules="rules.date"></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="primary" v-model="profile.user_birthdate" :max="today"></v-date-picker>
									</v-menu>
								</div>
								<div class="pb-4" v-if="type == 'user_gender'">
									<div class="text-body-1 text-left font-weight-bold pb-1">Jenis Kelamin</div>
									<v-autocomplete v-model="profile.user_gender" label="Jenis Kelamin" :items="gender" single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" :rules="rules.gender"></v-autocomplete>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions class="pt-0">
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="save" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Simpan</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			menu:false,
			rules: {
				name: [
				v => !!v || 'Nama tidak boleh kosong',
				],
				date: [
				v => !!v || 'Tanggal Lahir tidak boleh kosong',
				],
				gender: [
				v => !!v || 'Jenis Kelamin tidak boleh kosong',
				],
			},
			profile: {},
			type: '',
			gender: ['Pria', 'Wanita']
		}
	},
	computed: {
		...mapState('auth', ['userData']),

		tittle() {
			switch (this.type) {
				case 'user_name':
				return 'Ubah Nama'

				case 'user_birthdate':
				return 'Ubah Tanggal'

				default:
				return 'Ubah Data'
			}
		}
	},
	methods: {
		modalShow(type, data) {
			this.dialog = true
			this.type = type
			this.profile = Object.assign({}, data)
			if (this.profile.user_birthdate == '0000-00-00') {
				this.profile.user_birthdate = null
			}
		},
		modalHide() {
			this.dialog = false
		},
		save() {
			if (this.$refs.formProfile.validate()) {
				this.$emit('action', this.profile)
				this.modalHide()
			}
		}
	}
};
</script>